import React from 'react';
import PropTypes from 'prop-types';

export const FormWrapper = ({ children }) => {
  return (
    <div className="swform swticketform pl3 pr3 pb3">
      <div className="swformsection">{children}</div>
    </div>
  );
};

FormWrapper.propTypes = {
  children: PropTypes.any
};
